import { render, staticRenderFns } from "./AppConfig.vue?vue&type=template&id=4bb3e63a&scoped=true"
import script from "./AppConfig.vue?vue&type=script&lang=js"
export * from "./AppConfig.vue?vue&type=script&lang=js"
import style0 from "./AppConfig.vue?vue&type=style&index=0&id=4bb3e63a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bb3e63a",
  null
  
)

export default component.exports